import { useContext } from "react";
import { LanguageContext } from "@/i18n";

export default function Marquee() {
  const { t } = useContext(LanguageContext);
  const items = [...t.marquee, ...t.marquee, ...t.marquee];

  return (
    <div data-testid="marquee-section" dir="ltr" className="relative border-y border-white/10 bg-[#0D0D0D] py-6 overflow-hidden">
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center shrink-0">
            {items.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center shrink-0">
                <span className="font-display font-bold text-2xl md:text-3xl tracking-tight text-zinc-700 hover:text-[#00F0FF] transition-colors duration-500 px-8 whitespace-nowrap">
                  {item}
                </span>
                <span className="w-1.5 h-1.5 rotate-45 bg-[#00F0FF]/40 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
      <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#0A0A0A] to-transparent pointer-events-none" />
      <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#0A0A0A] to-transparent pointer-events-none" />
    </div>
  );
}
